import NProgress from 'nprogress';
import 'nprogress/nprogress.css';


NProgress.configure({
    showSpinner: false,
    trickleSpeed: 100, 
    minimum: 0.2,
    easing: 'ease',
    speed: 500,
  });

export default NProgress;